module.exports = "<sx-template-listado \r\n  [titulo]=\"'Reports'\"\r\n  [listado]=\"reports\"> \r\n</sx-template-listado>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reportConfiguration/list.report.configuration.component.html
// module id = ../../../../../src/app/private/reportConfiguration/list.report.configuration.component.html
// module chunks = main